'use client';

import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion as AccordionPrimitive } from 'radix-ui';
import { tv } from 'tailwind-variants';
import { faChevronRight } from '@icons/classic/regular';
const accordion = tv({
  base: `
    w-full
  `
});
// ACCORDION
function Accordion(t0) {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = accordion();
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <AccordionPrimitive.Root className={t1} data-slot="accordion" {...props} />;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}

// ACCORDION ITEM
const accordionItem = tv({
  variants: {
    withBorder: {
      true: `
        border
        border-border-secondary
        rounded-lg
      `,
      false: `
        border-b-0
      `
    }
  },
  base: `
    
  `
});
function AccordionItem(t0) {
  const $ = _c(10);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      withBorder: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const withBorder = t1 === undefined ? true : t1;
  let t2;
  if ($[4] !== className || $[5] !== withBorder) {
    t2 = accordionItem({
      withBorder,
      className
    });
    $[4] = className;
    $[5] = withBorder;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== t2) {
    t3 = <AccordionPrimitive.Item className={t2} data-slot="accordion-item" {...props} />;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}

// ACCORDION TRIGGER
const accordianTrigger = tv({
  slots: {
    trigger: `
      p-4
      focus-visible:border-ring
      focus-visible:ring-ring/50
      flex
      flex-1
      items-center
      justify-between
      gap-4
      rounded-md
      text-left
      text-sm
      font-medium
      transition-all
      outline-none
      focus-visible:ring-[3px]
      disabled:pointer-events-none
      disabled:opacity-50
      [&[data-state=open]>svg]:rotate-90
      cursor-pointer
      hover:bg-background-secondary
    `,
    icon: `
      text-muted-foreground
      pointer-events-none
      size-4
      shrink-0
      transition-transform
      duration-200
    `
  }
});
function AccordionTrigger(t0) {
  const $ = _c(30);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let T0;
  let T1;
  let T2;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[4] !== children || $[5] !== className || $[6] !== props) {
    const {
      icon,
      trigger
    } = accordianTrigger();
    T2 = AccordionPrimitive.Header;
    t6 = "flex";
    T1 = AccordionPrimitive.Trigger;
    t2 = trigger({
      className
    });
    t3 = "accordion-trigger";
    t4 = props;
    t5 = children;
    T0 = FontAwesomeIcon;
    t1 = icon();
    $[4] = children;
    $[5] = className;
    $[6] = props;
    $[7] = T0;
    $[8] = T1;
    $[9] = T2;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    T0 = $[7];
    T1 = $[8];
    T2 = $[9];
    t1 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
  }
  let t7;
  if ($[16] !== T0 || $[17] !== t1) {
    t7 = <T0 className={t1} icon={faChevronRight} />;
    $[16] = T0;
    $[17] = t1;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== T1 || $[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t7) {
    t8 = <T1 className={t2} data-slot={t3} {...t4}>{t5}{t7}</T1>;
    $[19] = T1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== T2 || $[27] !== t6 || $[28] !== t8) {
    t9 = <T2 className={t6}>{t8}</T2>;
    $[26] = T2;
    $[27] = t6;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
}

// ACCORDION CONTENT
const accordionContent = tv({
  base: `
    p-4
    pt-0
  `
});
function AccordionContent(t0) {
  const $ = _c(12);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = accordionContent({
      className
    });
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== t1) {
    t2 = <div className={t1}>{children}</div>;
    $[6] = children;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== props || $[10] !== t2) {
    t3 = <AccordionPrimitive.Content className="data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm" data-slot="accordion-content" {...props}>{t2}</AccordionPrimitive.Content>;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export { accordianTrigger, Accordion, accordionContent, AccordionContent, accordionItem, AccordionItem, AccordionTrigger };